module.exports = __webpack_public_path__ + "fonts/effect-soul-seeker-6ad724.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-soul-seeker.svg
// module id = 831
// module chunks = 0